import React, { useState } from 'react';
import AdminLayout from '../../components/Admin/AdminLayout';
import DataTable from '../../components/Admin/DataTable';

export default function ContactMessages() {
    // Mock data for display purposes
    const [data] = useState([
        {
            id: 1,
            name: 'John Doe',
            email: 'john@example.com',
            subject: 'Inquiry about Services',
            message: 'I would like to know more about your automation services...',
            date: '2025-01-21',
            status: 'New'
        },
        {
            id: 2,
            name: 'Jane Smith',
            email: 'jane@company.com',
            subject: 'Partnership Opportunity',
            message: 'We are looking for a tech partner for our upcoming project...',
            date: '2025-01-19',
            status: 'Read'
        }
    ]);
    const [selectedMessage, setSelectedMessage] = useState(null);

    const columns = [
        {
            header: 'From',
            accessor: 'name',
            render: (item) => (
                <div>
                    <div className="font-medium text-white">{item.name}</div>
                    <div className="text-xs text-gray-500">{item.email}</div>
                </div>
            )
        },
        {
            header: 'Subject',
            accessor: 'subject',
            render: (item) => (
                <span className="text-gray-300 font-medium">{item.subject}</span>
            )
        },
        {
            header: 'Message Preview',
            accessor: 'message',
            render: (item) => (
                <span className="text-gray-500 text-xs line-clamp-1 max-w-xs">{item.message}</span>
            )
        },
        {
            header: 'Status',
            accessor: 'status',
            render: (item) => (
                <span className={`px-2 py-1 text-xs font-semibold rounded-full ${item.status === 'New'
                    ? 'bg-blue-900/30 text-blue-400 border border-blue-800/50'
                    : 'bg-gray-800 text-gray-400 border border-gray-700'
                    }`}>
                    {item.status}
                </span>
            )
        },
        {
            header: 'Date',
            accessor: 'date'
        }
    ];

    return (
        <AdminLayout>
            <div className="flex flex-col space-y-4">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 flex-none">
                    <div className="flex space-x-4 flex-1">
                        {/* Search */}
                        <div className="relative flex-1 max-w-md">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <svg className="h-5 w-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                            </div>
                            <input
                                type="text"
                                placeholder="Search messages..."
                                className="w-full pl-10 pr-4 py-2 bg-[#1a1025] border border-white/10 rounded-lg focus:outline-none focus:border-blue-500 text-gray-300 placeholder-gray-500"
                            />
                        </div>

                        {/* Filter Placeholder */}
                        <select
                            className="px-4 py-2 bg-[#1a1025] border border-white/10 rounded-lg focus:outline-none focus:border-blue-500 text-gray-300"
                        >
                            <option value="">All Statuses</option>
                            <option value="New">New</option>
                            <option value="Read">Read</option>
                        </select>
                    </div>
                </div>

                {/* <div className="bg-[#1a1025] rounded-xl border border-white/5 p-4 shadow-xl mb-6 flex-none">
                    <p className="text-gray-400 text-sm">
                        Contact Messages module is coming soon because the backend is not yet implemented. This is a mock display.
                    </p>
                </div> */}

                <div>
                    <DataTable
                        columns={columns}
                        data={data}
                        isLoading={false}
                        actions={false}
                        onRowClick={(item) => setSelectedMessage(item)}
                    />

                    {/* Message Details Modal */}
                    {selectedMessage && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setSelectedMessage(null)}>
                            <div
                                className="bg-[#1a1025] rounded-2xl border border-white/10 w-full max-w-2xl shadow-2xl overflow-hidden"
                                onClick={e => e.stopPropagation()}
                            >
                                <div className="p-6 border-b border-white/5 flex justify-between items-start">
                                    <div>
                                        <h3 className="text-xl font-bold text-white mb-1">{selectedMessage.subject}</h3>
                                        <div className="flex items-center gap-2 text-sm text-gray-400">
                                            <span>From: <span className="text-white">{selectedMessage.name}</span></span>
                                            <span>•</span>
                                            <span>{selectedMessage.email}</span>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => setSelectedMessage(null)}
                                        className="text-gray-400 hover:text-white transition-colors"
                                    >
                                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="p-6">
                                    <div className="flex items-center gap-2 mb-6">
                                        <span className={`px-2 py-1 text-xs font-semibold rounded-full ${selectedMessage.status === 'New'
                                            ? 'bg-blue-900/30 text-blue-400 border border-blue-800/50'
                                            : 'bg-gray-800 text-gray-400 border border-gray-700'
                                            }`}>
                                            {selectedMessage.status}
                                        </span>
                                        <span className="text-sm text-gray-500">{selectedMessage.date}</span>
                                    </div>
                                    <div className="prose prose-invert max-w-none">
                                        <p className="text-gray-300 leading-relaxed whitespace-pre-wrap">
                                            {selectedMessage.message}
                                        </p>
                                    </div>
                                </div>
                                <div className="p-6 border-t border-white/5 bg-white/5 flex justify-end gap-3">
                                    <button
                                        onClick={() => setSelectedMessage(null)}
                                        className="px-4 py-2 rounded-lg text-sm font-medium text-gray-300 hover:text-white hover:bg-white/5 transition-colors"
                                    >
                                        Close
                                    </button>

                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </AdminLayout>
    );
}
